/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Customer Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomerFeatureType,
    CustomerFeatureTypeFromJSON,
    CustomerFeatureTypeFromJSONTyped,
    CustomerFeatureTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomerFeature
 */
export interface CustomerFeature {
    /**
     * 
     * @type {CustomerFeatureType}
     * @memberof CustomerFeature
     */
    feature: CustomerFeatureType;
    /**
     * Feature value (all features does not have a value)
     * @type {string}
     * @memberof CustomerFeature
     */
    value?: string;
}

export function CustomerFeatureFromJSON(json: any): CustomerFeature {
    return CustomerFeatureFromJSONTyped(json, false);
}

export function CustomerFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerFeature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feature': CustomerFeatureTypeFromJSON(json['feature']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function CustomerFeatureToJSON(value?: CustomerFeature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feature': CustomerFeatureTypeToJSON(value.feature),
        'value': value.value,
    };
}


